<template>
  <div 
    v-if="languages && languages.length > 1"
    style="position: fixed; top: 10px; right: 10px;z-index: 100;"
  >
    <v-menu 
      bottom
      left
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          :color="color"
          dark
          v-bind="attrs"
          v-on="on"
          fab
          small
          text
          elevation="0"
          style="text-shadow: 1px 1px gray;"
        >
        {{locale}}
        </v-btn>
      </template>
      <v-list>
        <v-list-item
          v-for="(item, index) in languages"
          :key="index"
          @click="handleChangeLocale(item)"
        >
          <v-list-item-title style="text-align: center;">{{ item }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>
<script>
export default {
  props: {
    languages: {
      type: Array,
      default: null,
    },
    bgColor: {
      type: String,
      default: null,
    },
    color: {
      type: String,
      default: null,
    },
    locale: {
      type: String,
      required: true,
    },
  },
  methods: {
    handleChangeLocale (v) {
      localStorage.setItem('locale', v)
      this.$store.state.app.locale = v
    },
  },
}
</script>

